import React, { useEffect, useState } from "react";
import ToastNotification from '../../../components/ToastNotification';
import { FaRegEye } from "react-icons/fa";
import { FcAcceptDatabase } from "react-icons/fc";
import { FcApproval } from "react-icons/fc";
import { RxCrossCircled } from "react-icons/rx";
import axios from "axios";

function DeniedCall({adminData ,branchID,financialYear}) {

    

    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });

    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };
    const [statusFilter, setStatusFilter] = useState("denied-pending");
    const [complaints, setComplaints] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
        const [actionStatus, setActionStatus] = useState("");

        const [showStatusModal, setShowStatusModal] = useState(false);
    
        const [statusForm, setStatusForm] = useState({
            remark: "",
            date: "",
            emp_id: adminData?.user?.emp_id || ""
        });
    
 const limit = 20;
    const [offset, setOffset] = useState(0);
                    const [hasMore, setHasMore] = useState(true);
                    const [fromDate, setFromDate] = useState();
                    const [toDate, setToDate] = useState();
     const [isLocked, setIsLocked] = useState(false);
     const [fy, setFy] = useState([]);
       const [branchDetail, setBranchDetail] = useState([])
                  
    const [financialRange, setFinancialRange] = useState({
     from_date: '',
     to_date: ''
 });


    const filteredComplaints = complaints.filter(
        (row) =>
            row.call_status?.toLowerCase() === statusFilter.toLowerCase()
    );



    const fetchComplaints = async (fromDate,
    toDate,
    branchCode,
    newOffset = 0) => {
    
        if (!branchCode) {
      console.log("Branch code missing");
      return;
    }

        try {
            const res = await axios.get("https://api.skyguard.group/api/fetch-complaint",
                 {
          params: {
            from_date: fromDate,
            to_date: toDate,
            branchId: branchCode,
            limit: limit,
            offset: newOffset
          }
        }
            );
          
            // setComplaints(res.data);

             const result = res.data;
      if (newOffset === 0) {
       setComplaints(result);
        setHasMore(true);
      }

      else {
        setComplaints(prev => {
          const merged = [...prev, ...result];

          // optional: remove duplicates (safety)
          const unique = Array.from(
            new Map(merged.map(item => [item.id, item])).values()
          );

          return unique;
        });
      }

      if (result.length < limit) {
        setHasMore(false);
      }

        } catch (err) {
            console.error(err);
        }
    };

    
  const fetchBranchDetail = async () => {
   
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } 
    };

      const fetchYearDetail = async () => {
                                 
                try {
                                        const branchCode = await fetchBranchDetail();
                                     
                                        const res = await axios.get(
                                            `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
                                        );
                                        const yearData = res.data;
                                        setFy(yearData);
                                        setIsLocked(yearData.is_locked === 1);
                                        setFinancialRange({
                                            from_date: yearData.from_date,
                                            to_date: yearData.to_date
                                        });
                            
                                        await fetchComplaints(
                                            yearData.from_date,
                                            yearData.to_date,
                                            branchCode,
                            
                                        );
                                    } catch (error) {
                                        console.log(error);
                                    } 
                                };


    useEffect(() => {
        // fetchComplaints();
         fetchYearDetail ();
        fetchBranchDetail();
    }, [])

    const renderItemNames = (items) => {
        if (!items) return "-";

        try {
            const parsedItems = JSON.parse(items);
            return parsedItems.map((item, index) => (
                <div key={index}>
                    {item.name}
                </div>
            ));
        } catch (error) {
            console.error("Invalid items JSON", error);
            return "Invalid item data";
        }
    };

    const getItemNamesString = (items) => {
        if (!items) return "";

        try {
            const parsedItems = JSON.parse(items);
            return parsedItems.map(item => item.name).join(", ");
        } catch (error) {
            console.error("Invalid items JSON", error);
            return "";
        }
    };


    const handleView = (row) => {
        setSelectedRow(row);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedRow(null);
    };



       const handleSubmit = async () => {
            try {
                const callRemarkHistory = {
                    remark: statusForm.remark,
                    date: statusForm.date,
                    emp_id: statusForm.emp_id
                };
    
                await axios.put("https://api.skyguard.group/api/update-call-status", {
                    id: selectedRow.id,
                    status: actionStatus,
                    call_remark_history: callRemarkHistory   
                });
    
                showToast("Call Status updated Successfully", "success");
    
    
                setStatusForm({ remark: "", date: "", emp_id: "" });
            
                setShowStatusModal(false);
                
    
                fetchComplaints();
            } catch (err) {
                console.error(err);
                showToast("Call Update failed", "danger");
            }
        };

  const getRemarkText = (remarks) => {
        try {
            if (!remarks) return "";

            // If remarks is JSON string
            if (typeof remarks === "string" && remarks.trim().startsWith("{")) {
                const parsed = JSON.parse(remarks);
                return parsed?.remarks || "";
            }

            // If remarks is already an object
            if (typeof remarks === "object") {
                return remarks?.remarks || "";
            }

            // Plain string
            return remarks;
        } catch (err) {
            return "";
        }
    };



    const formatStatusHistory = (call_status_date) => {
    if (!call_status_date) return "";

    try {
        const obj =
            typeof call_status_date === "string"
                ? JSON.parse(call_status_date)
                : call_status_date;

        return Object.entries(obj)
            .map(([status, value]) => {
                // handle both old + new structure
                const date = typeof value === "string" ? value : value?.date;
                const emp_id = typeof value === "object" ? value?.emp_id : null;

                const formattedDate = date
                    ? new Date(date).toLocaleString()
                    : "N/A";

                return `${status.toUpperCase()} : ${formattedDate} ${
                    emp_id ? `(EMP: ${emp_id})` : ""
                }`;
            })
            .join("\n");
    } catch (err) {
        return "";
    }
};


    const formatCallRemarkHistory = (call_remark_history) => {
        if (!call_remark_history) return "";

        try {
            const data =
                typeof call_remark_history === "string"
                    ? JSON.parse(call_remark_history)
                    : call_remark_history;

            if (!Array.isArray(data)) return "";

            return data
                .map(
                    (item, index) =>
                        `${index + 1}. ${item.remark} | ${item.date}  | ${item.emp_id}`
                )
                .join("\n");
        } catch (err) {
            console.error("Parse error:", err);
            return "";
        }
    };


     const handleLoadMore = () => {

    const nextOffset = offset + limit;
    setOffset(nextOffset);

    fetchComplaints(
      financialRange.from_date,
      financialRange.to_date,
      branchDetail.code,
      nextOffset
    );
  };

    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />

                <div className="row gx-4 gy-2 align-items-center">

                    <div className="col-md-6">
                        <label className="form-label fw-medium">Search</label>
                        <input
                            type="text"
                            className="form-control border-0 border-bottom border-dark"
                            placeholder="Search..."
                        // value={search}
                        // onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>

                    <div className="col-md-6 justify-content-end">
                        <label className="form-label fw-medium">Select Status</label>
                        <select
                            className="form-select"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                        >

                            <option value="denied-pending">Pending</option>
                            <option value="denied-approved">Approved</option>
                            <option value="denied-rejected">Rejected</option>
                        </select>
                    </div>

                </div>

                <hr />


                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>



                    {statusFilter === "denied-pending" && (
                        <table className="table table-bordered table-striped text-center table-sm align-middle">
                            <thead className="table-info">
                                <tr>
                                     <th>View</th>
                                    <th>Actions</th>
                                    <th>Ref</th>
                                    <th>Date</th>
                                    <th>Party Name</th>
                                    <th>Phones</th>
                                    <th>Address</th>
                                    <th>Items</th>
                                    <th>Description</th>
                                   
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {complaints
                                    .filter((row) => row.call_status === "denied-pending")
                                    .map((row) => (
                                        <tr key={row.id}>

                                             <td>
                                                <FaRegEye
                                                    size={26}
                                                    className="ms-1 text-primary"
                                                    title="View"
                                                    onClick={() => handleView(row)}
                                                />
                                            </td>

                                            <td className="d-flex justify-content-around">
                                                <FcAcceptDatabase size={26} className="text-success" title="accepted" 
                                                // onClick={() => handleSubmit(row.id, "accepted")}
                                                                    onClick={() => {
                                                        setActionStatus("accepted");
                                                        setShowStatusModal(true);
                                                        setSelectedRow(row)
                                                    }}
                                                
                                                />
                                                <FcApproval size={26} className="text-warning" title="Approved"
                                                //  onClick={() => handleSubmit(row.id, "denied-approved")}
                                                  onClick={() => {
                                                        setActionStatus("denied-approved");
                                                        setShowStatusModal(true);
                                                        setSelectedRow(row)
                                                    }}
                                                 
                                                 />
                                                <RxCrossCircled size={26} className="text-danger" title="Rejected"
                                                //  onClick={() => handleSubmit(row.id, "denied-rejected")}
                                                onClick={() => {
                                                        setActionStatus("denied-rejected");
                                                        setShowStatusModal(true);
                                                        setSelectedRow(row)
                                                    }}
                                                 
                                                 />
                                            </td>
                                            <td>{`CMP/${row.branch}/${row.ref_doc}`}</td>
                                            <td>{row.date} </td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_phone} {row.party_mobile}</td>
                                            {/* <td>{row.party_address}</td> */}
                                                <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>
                                            <td>{renderItemNames(row.items)}</td>
                                            <td>{row.description}</td>
                                       


                                            
                                            <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    )}

                    {statusFilter === "denied-approved" && (
                        <table className="table table-bordered table-striped text-center table-sm align-middle">
                            <thead className="table-success">
                                <tr>
                                       <th>View</th>
                                    <th>Ref</th>
                                    <th>Party Name</th>
                                    <th>Phones</th>
                                    <th>Address</th>
                                    <th>Items</th>
                                    <th>Description</th>
                                 

                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {complaints
                                    .filter((row) => row.call_status === "denied-approved")
                                    .map((row) => (
                                        <tr key={row.id}>
                                             <td>
                                                <FaRegEye
                                                    size={26}
                                                    className="ms-1 text-primary"
                                                    title="View"
                                                    onClick={() => handleView(row)}
                                                />
                                            </td>
                                            <td>{`CMP/${row.branch}/${row.ref_doc}`}</td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_phone} {row.party_mobile}</td>
                                            {/* <td>{row.party_address}</td> */}
                                                <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>
                                            <td>{renderItemNames(row.items)}</td>
                                            <td>{row.description}</td>
                                           

                                            {/* <td>{row.remarks}</td> */}
                                              <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>
                                            

                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    )}

                    {statusFilter === "denied-rejected" && (
                        <table className="table table-bordered table-striped text-center table-sm align-middle">
                            <thead className="table-danger">
                                <tr>
                                      <th>View</th>
                                    <th>Ref</th>
                                    <th>Party Name</th>
                                    <th>Phones</th>
                                    <th>Address</th>
                                    <th>Items</th>
                                    <th>Description</th>
                                  

                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {complaints
                                    .filter((row) => row.call_status === "denied-rejected")
                                    .map((row) => (
                                        <tr key={row.id}>
                                              <td>
                                                <FaRegEye
                                                    size={26}
                                                    className="ms-1 text-primary"
                                                    title="View"
                                                    onClick={() => handleView(row)}
                                                />
                                            </td>
                                            <td>{`CMP/${row.branch}/${row.ref_doc}`}</td>
                                            <td>{row.party_name}</td>
                                            <td>{row.party_phone} {row.party_mobile}</td>
                                            {/* <td>{row.party_address}</td> */}
                                                <td>{row.party_state || ''}, {row.party_city || ''},{row.party_region || ""},{row.party_pincode || ''}  </td>
                                            <td>{renderItemNames(row.items)}</td>
                                            <td>{row.description}</td>
                                          

                                            {/* <td>{row.remarks}</td> */}

                                              <td>
                                                {(() => {
                                                    try {

                                                        const r = typeof row.remarks === "string" ? JSON.parse(row.remarks) : row.remarks;
                                                        return r?.remarks || "";
                                                    } catch (err) {
                                                        return row.remarks || "";
                                                    }
                                                })()}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    )}

                </div>

                {showModal && (
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-md modal-dialog-centered">
                            <div className="modal-content">

                                {/* Header */}
                                <div className="modal-header">
                                    <h5 className="modal-title">Complaint Details</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={closeModal}
                                    ></button>
                                </div>

                                {/* Body */}
                                <div className="modal-body">

                                    <div className="row g-2">
                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary">Doc </label>
                                            <input className="form-control" value={`CMP/${selectedRow?.branch}/${selectedRow?.ref_doc}`} />
                                        </div>

                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary ">Date  </label>
                                            <input className="form-control" value={selectedRow.date} />
                                        </div>

                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary ">Party </label>
                                            <input className="form-control" value={selectedRow.party_name} />
                                        </div>

                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary ">Party Address  </label>
                                            <input className="form-control" value={selectedRow.party_address} />
                                        </div>
                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary ">Item </label>
                                            <input
                                                className="form-control"
                                                rows={3}
                                                value={getItemNamesString(selectedRow?.items)}
                                                readOnly
                                            />

                                        </div>

                                        <div className="col-6">
                                            <label className="form-label fw-medium text-primary ">Remark  </label>
                                            <textarea className="form-control" value={getRemarkText(selectedRow.remarks)} />
                                        </div>

                                          <div className="col-12">
                                            <label className="form-label fw-medium text-primary">
                                                Date History
                                            </label>

                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                readOnly
                                                value={formatStatusHistory(selectedRow?.call_status_date)}
                                            />
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label fw-medium text-primary">
                                                Remark History
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                readOnly
                                                value={formatCallRemarkHistory(selectedRow?.call_remark_history)}
                                            />

                                        </div>

                                    </div>


                                </div>

                                {/* Footer */}
                                <div className="modal-footer">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={closeModal}
                                    >
                                        Close
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                )}



                  {showStatusModal && (
                    <div className="modal show d-block mt-4" style={{ background: "rgba(0,0,0,0.4)" }}>
                        <div className="modal-dialog ">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h6 className="modal-title">Add Remark</h6>
                                    <button
                                        className="btn-close"
                                        onClick={() => setShowStatusModal(false)}
                                    />
                                </div>

                                {/* <div className="modal-body">
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={nextFollowupDate}
                                        onChange={(e) => setNextFollowupDate(e.target.value)}
                                    />
                                </div> */}

                                <div className="modal-body">
                                    <label className="form-label fw-medium text-primary">Remark</label>
                                    <textarea
                                        className="form-control"
                                        value={statusForm.remark}
                                        onChange={(e) =>
                                            setStatusForm({ ...statusForm, remark: e.target.value })
                                        }
                                    />
                                </div>


                                <div className="modal-body">
                                    <label className="form-label fw-medium text-primary">Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={statusForm.date}
                                        onChange={(e) =>
                                            setStatusForm({ ...statusForm, date: e.target.value })
                                        }
                                    />
                                </div>



                                <div className="modal-footer">
                                
                                    <button className="btn btn-success" onClick={handleSubmit}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

 {hasMore && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-primary"
                  onClick={handleLoadMore}
                >
                  Load More
                </button>
              </div>
            )}
            </div>

        </div>
    )
}

export default DeniedCall